module.exports = __webpack_public_path__ + "static/media/client-logo-desktop_b.26e8b9fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/client-logo-desktop_b.png
// module id = 554
// module chunks = 0